<template>
  <div>
    <div :class="[$style.title, 'login-heading']"></div>
    <div :class="$style.block">
      <div class="row">
        <div class="col-xl-12">
          <div :class="$style.inner">
            <div :class="$style.form">
              <center>
                <img src="resources/images/logos/logo.png" width="250" style="object-fit: contain;">
              </center>
              <br />
              <center>
                <h4>
                  <strong>Cambia contraseña</strong>
                </h4>
              </center>
              <a-form class="login-form" :form="form" @submit="handleSubmit">
                <a-form-item label="Correo">
                  <a-input
                    placeholder="Correo"
                    v-decorator="[
                      'correo',
                      {
                        initialValue: $route.params.correo,
                        rules: [
                          {
                            required: true,
                            message: 'Please input your username!',
                          },
                        ],
                      },
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="user"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input>
                </a-form-item>
                <a-form-item label="Nueva Contraseña">
                  <a-input
                    placeholder="Nueva Contraseña"
                    type="password"
                    v-decorator="[
                      'contrasena_nueva',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa la contraseña',
                          },
                        ],
                      },
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input>
                </a-form-item>
                <a-form-item label="Confirmar Contraseña">
                  <a-input
                    placeholder="Confirmar Contraseña"
                    type="password"
                    v-decorator="[
                      'contrasena_confirm',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa la contraseña',
                          },
                        ],
                      },
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input>
                </a-form-item>
                <div class="form-actions">
                  <button type="submit" class="btn btn-primary btn-block">
                    CAmbiar contraseña
                  </button>
                </div>
              </a-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    console.log(this.$route.params.correo);
    console.log(this.$route.params.token);
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          values.token_recuperar = this.$route.params.token
          this.$nprogress.start()
          this.$store.dispatch('LOADING')
          console.log(values)
          this.logear(values)
        }
      })
    },

    async logear(body) {
      const cambiarContraseña = await this.$store.dispatch('RECOVER_PASSWORD', body)
      console.log(cambiarContraseña)
      this.$nprogress.done()
      this.$store.dispatch('LOADED')
      if (cambiarContraseña.status === 'error') {
        this.$swal({
          toast: false,
          position: 'center',
          showConfirmButton: true,
          icon: 'error',
          title: cambiarContraseña.message,
        })
      }
    },
  },
};
</script>

<style lang="scss" module>
@import "../login/style.module.scss";
</style>